import { createApi } from "@reduxjs/toolkit/query/react";
import { appBaseQuery } from "../../services/baseQuery";
import { buildPagedListUrl } from "../../services/queryParams";

export const relationTypeApi = createApi({
  reducerPath: "relationTypeApi",
  baseQuery: appBaseQuery,
  tagTypes: ["RelationType"],
  endpoints: (builder) => ({
    getRelationTypes: builder.query({
      query: (params = {}) => buildPagedListUrl("relation/", params),
      providesTags: ["RelationType"],
    }),
    addRelationType: builder.mutation({
      query: (newRelationType) => ({
        url: "relation/",
        method: "POST",
        body: newRelationType,
      }),
      invalidatesTags: ["RelationType"],
    }),
    updateRelationType: builder.mutation({
      query: ({ uid, ...updatedRelationType }) => ({
        url: `relation/${uid}`,
        method: "PUT",
        body: updatedRelationType,
      }),
      invalidatesTags: ["RelationType"],
    }),
    deleteRelationType: builder.mutation({
      query: (uid) => ({
        url: `relation/${uid}`,
        method: "DELETE",
      }),
      invalidatesTags: ["RelationType"],
    }),
  }),
});

export const {
  useGetRelationTypesQuery,
  useLazyGetRelationTypesQuery,
  useAddRelationTypeMutation,
  useUpdateRelationTypeMutation,
  useDeleteRelationTypeMutation,
} = relationTypeApi;
